import {useEffect, useState} from 'react'

/**
 * Debounces a value by the specified delay. Useful for delaying expensive operations like API calls until the user has stopped typing.
 *
 * @param value The value to debounce, only works for primitive values (string, number, boolean).
 * @param delay The delay in milliseconds.
 * 
 * @example
 *  const nationalId = useDebouncedState(
       useStore(form.store, state => state.values.nationalId),
       500
    )
 */
export function useDebouncedState<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return debounced
}
